export const random = (min: number, max: number) => {
    return Math.floor(min + Math.random() * (max - min));
};

export const getImageUrl = (assetUrlWithOpts: string, opts: string): string => {
    return assetUrlWithOpts.replace("[OPTS]", opts);
};
